<template>
  <div class="base-info">
    <formTemplate :title="'其他'" :rules="rules" :formData="other_info">
      <template v-slot:body>
        <el-form-item label="运费类型" prop="shipping_fee_type">
          <el-radio-group v-model="other_info.shipping_fee_type" @change="shippingFeeTypeChange">
            <el-radio :label="0">固定运费</el-radio>
            <el-radio :label="1">运费模板</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 运费金额（条件显示：当运费类型为固定运费时显示） -->
        <el-form-item v-if="other_info.shipping_fee_type === 0" label="运费金额" prop="shipping_fee">
          <el-input style="width: 60%;" v-model="other_info.shipping_fee" :min="0" :precision="2" :step="0.1"
            placeholder="请输入运费金额" />
          <span class="unit-suffix margin-left-sm">元</span>
        </el-form-item>

        <!-- 运费模板（条件显示：当运费类型为运费模板时显示） -->
        <el-form-item v-if="other_info.shipping_fee_type === 1" label="运费模板" prop="shipping_template_id">
          <el-select style="width: 60%;" v-model="other_info.shipping_template_id" placeholder="请选择运费模板" filterable>
            <el-option v-for="item in shippingTempliteList" :key="item.template_id" :label="item.template_name"
              :value="item.template_id" />
          </el-select>
        </el-form-item>

        <!-- 商品状态开关组 -->
        <el-form-item label="商品状态">
          <el-row :gutter="20">
            <el-col :span="4">
              <el-switch v-model="other_info.is_on_sale" active-text="上架" inactive-text="下架" />
            </el-col>
            <el-col :span="4">
              <el-switch v-model="other_info.is_new" active-text="新品" inactive-text="非新品" />
            </el-col>
            <el-col :span="4">
              <el-switch v-model="other_info.is_hot" active-text="热销" inactive-text="非热销" />
            </el-col>
            <el-col :span="4">
              <el-switch v-model="other_info.is_recommend" active-text="推荐" inactive-text="非推荐" />
            </el-col>
          </el-row>
        </el-form-item>

        <!-- 排序号 -->
        <el-form-item label="排序号" prop="sort_order">
          <el-input v-model="other_info.sort_order" :min="0" :max="9999" :step="1" placeholder="请输入排序号" />
          <span class="unit-suffix margin-left-sm">数字越小越靠前</span>
        </el-form-item>
      </template>
    </formTemplate>
  </div>

</template>
<script>
import { myFixed } from '@/js/public.js';
import { mixinShippingTemplate } from '../../../mixin/shippingTemplate.js';
import formTemplate from './formTemplate.vue';
export default {
  name: 'logisticsInfo',
  components: {
    formTemplate
  },
  mixins: [mixinShippingTemplate],
  data() {
    return {
      shippingFeeTypeOptions: [
        { value: 0, label: '固定运费' },
        { value: 1, label: '运费模板' }
      ],
      shipping_template_options: [],
      other_info: {
        shipping_fee_type: 0,
        shipping_fee: "",
        shipping_template_id: "",
        is_on_sale: true,
        is_new: true,
        is_hot: false,
        is_recommend: true,
        sort_order: 100
      },
      rules: {
        shipping_fee_type: [
          { required: true, message: '请选择运费类型', trigger: 'change' }
        ],
        shipping_fee: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        shipping_template_id: [
          { required: true, message: '请选择运费模板', trigger: 'change' }
        ],
        sort_order: [
          { required: true, message: '请输入排序值', trigger: 'blur' }
        ]
      }

    }
  },
  mounted() {
    this.getTemplateList();
  },
  methods: {
    shippingFeeTypeChange(e) {
      console.log(e);
      if (e === 0 || e === '0') {
        this.other_info.shipping_template_id = "";
      }
    },
    getValue() {
      return {
        ...this.other_info,
        shipping_fee: this.other_info.shipping_fee * 100
      }
    },
    setValue(v) {
      console.log("logisticsInfo", v);
      this.other_info = v;
      this.other_info.shipping_fee = myFixed(v.shipping_fee * 0.01, 2);
    }
  }
};
</script>
<style lang="less" scoped>
.el-input {
  width: 60%;
}
</style>